exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip {\n\tbackground: #2A3F54;\n\tcolor: #fff;\n\tpadding: 3px 5px;\n\topacity: 1 !important;\n}\n\n.dropdown-menu {\n    background: #F7F7F7 !important;\n}\n\n.rm-dropdown-menu { left: auto !important; }\n\n.panel-body.sales-chart svg > g {\n    -webkit-transform: translate(100px, 10px);\n            transform: translate(100px, 10px);\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-1!./node_modules/postcss-loader/lib!./src/app/views/home/home.css
// module id = 361
// module chunks = 0